import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class WarehouseTransfers_ds_get_warehouse_transfer_by_warehouseTransferIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { warehouseTransferId: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Notes?: string, SourceWarehouseId?: number, TargetWarehouseId?: number, SourceOutboundOrder?: { Id?: number, LookupCode?: string, OrderStatusId?: number, RequestedDeliveryDate?: string, OrderLines?: { LineNumber?: number }[], ShipmentOrderLookups?: { CreatedSysDateTime?: string, Shipment?: { Id?: number, StatusId?: number } }[] }, TargetInboundOrder?: { Id?: number, LookupCode?: string, OrderStatusId?: number, RequestedDeliveryDate?: string, ShipmentOrderLookups?: { CreatedSysDateTime?: string, Shipment?: { Id?: number, StatusId?: number } }[] }, Project?: { Id?: number, OwnerId?: number }, Status?: { Id?: number, Name?: string } } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.warehouseTransferId)) {
      missingRequiredInParams.push('\'warehouseTransferId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/WarehouseTransfers/datasources/ds_get_warehouse_transfer_by_warehouseTransferId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      warehouseTransferId: number    }) {
        if(isNil(inParams.warehouseTransferId)) {
          return true; 
        }
      return false;
    }
}
